import {EStatus} from './definitions';

export default {
  status: {
    [EStatus.DRAFT]: 'Draft',
    [EStatus.IN_PROGRESS]: 'Under consideration',
    [EStatus.CREATE_SUBJECT]: 'Under consideration',
    [EStatus.CREATE_SUBJECT_ERROR]: 'Problem',
    [EStatus.CANCELLED]: 'Disabled',
    [EStatus.DONE]: 'Correct',
  },
  editForm: {
    settings: 'Channel settings',
    subject: 'Sender',
    subjectHint:
      'The sender is a system channel name that is used within edna Pulse and is not displayed to recipients',
    name: 'Internal channel name',
    nameHint: 'This name will appear in the edna Pulse channel list and reports',
    token: 'Access token',
    tokenHint: "Insert the bot's access_token",
    sendingInfo:
      'You can only send messages through the MAX Bot channel after receiving a message from the recipient. Only MAX_ID can be used for messaging',
  },
  registrationCheck: {
    title: 'Required steps for MAX Bot registration:',
    points: [
      'Sign up for MAX. <1>Simplified registration via edna</1> <0></0> bypasses the need for RuStore or MSP platform verification',
      'You have successfully <2>verified your MAX account</2> <0></0>',
      'You have created a chatbot in the "Chatbot and Mini-app" section. <3>How to create a bot on MAX</3> <0></0>',
      'You have received your chatbot token in the "Integration" section of your MAX account',
    ],
  },
};
